//
//
//
//
//

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";

import media from "./mixins/media";

export default {
  name: "CalendarApp",
  mixins: [media],
  components: {
    FullCalendar,
  },
  data() {
    return {
      activePreview: null,
      activeDetail: null,
      error: false,
      calendar: null,
      overrides: {},
      calendarOptions: {
        height: "auto",
        events: [],
        plugins: [dayGridPlugin, listPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        eventClick: this.eventClick,
        eventMouseLeave: this.eventMouseLeave,
        eventMouseEnter: this.eventMouseEnter,
        dayHeaderFormat: { weekday: "long" },
        buttonText: {
          today: "today",
          month: "month",
          week: "week",
          day: "day",
          listMonth: "list",
        },
        headerToolbar: {
          start: "title",
          center: "today prev,next",
          end: "dayGridMonth,dayGridWeek,dayGridDay,listMonth",
        },
        eventTimeFormat: {
          hour: "numeric",
          minute: "2-digit",
          meridiem: "short",
        },
      },
    };
  },
  computed: {
    api() {
      return this.$root.api;
    },
    isListView() {
      return this.calendar.view.type.toLowerCase().includes("list");
    },
  },
  methods: {
    getData() {
      const revents = this.$root.rEvents;
      const mwfevents = this.$root.mwfEvents;
      const nodeguid = this.$root.nodeGuid;
      return new Promise((resolve) => {
        fetch(`${this.api}?revents=${revents}&mwfevents=${mwfevents}&nodeguid=${nodeguid}`)
          .then((res) => res.json())
          .then((data) => {
            this.overrides = data.overrides;
            this.calendarOptions.events = data.events;
          })
          .catch((error) => {
            console.error(error);
            this.error = true;
          })
          .finally(resolve);
      });
    },
    setLargeView() {
      this.calendar.changeView(this.overrides.initialView_large);
      this.calendarOptions.buttonText = {
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        listMonth: "list",
      };
      this.calendarOptions.headerToolbar = {
        start: "title",
        center: "dayGridMonth,dayGridWeek,dayGridDay,listMonth",
        end: "today prev,next",
      };
    },
    setSmallView() {
      this.calendar.changeView(this.overrides.initialView_small);
      this.calendarOptions.buttonText = {
        today: "today",
        listMonth: "month",
        listWeek: "week",
        listDay: "day",
      };
      this.calendarOptions.headerToolbar = {
        start: "title",
        end: "today listMonth,listWeek,listDay prev,next",
      };
    },
    setView() {
      if (!this.resize.observer) return;

      const size = this.resize.size;
      if (size === "XL" || size === "LG" || size === "MD") {
        this.setLargeView();
      } else {
        this.setSmallView();
      }
    },
    createPreview(event) {
      let preview = (this.activePreview = document.createElement("div"));
      let inner = document.createElement("div");
      preview.classList = "event__preview";
      preview.insertAdjacentElement("afterbegin", inner);
      inner.insertAdjacentHTML(
        "afterbegin",
        `<h6>${event.extendedProps.heading}</h6>`
      );
      return preview;
    },
    createDetail(event) {
      let detail = (this.activeDetail = document.createElement("div"));
      let inner = document.createElement("div");
      detail.classList = "event__detail";
      detail.insertAdjacentElement("afterbegin", inner);
      inner.insertAdjacentHTML(
        "afterbegin",
        `<h6>${event.extendedProps.heading}</h6>`
      );
      inner.insertAdjacentHTML(
        "beforeend",
        `<p>${event.extendedProps.copy}</p>`
      );
      return detail;
    },
    removeTooltips() {
      let status = { preview: false, detail: false };
      if (this.activePreview) {
        this.activePreview.remove();
        this.activePreview = null;
        status.preview = true;
      }
      if (this.activeDetail) {
        this.activeDetail.remove();
        this.activeDetail = null;
        status.detail = true;
      }
      return status;
    },
    eventClick(args) {
      args.jsEvent.preventDefault();
      if (this.isListView) {
        args.event.url ? window.open(args.event.url, "_blank") : false;
        return;
      }

      let alreadyOpen = this.removeTooltips().detail;
      if (alreadyOpen) return;
      args.event.url ? window.open(args.event.url, "_blank") : false;
    },
    eventMouseEnter(args) {
      if (this.isListView) return;

      this.removeTooltips();

      let preview = this.createPreview(args.event);
      args.el.insertAdjacentElement("beforeend", preview);
    },
    eventMouseLeave() {
      this.removeTooltips();
    },
		addintroText() {
			if (this.$root.introText && this.$root.introText.length > 0) {
				let parent = this.$refs.fullCalendar.$el;
				let h2 = parent.querySelector("h2.fc-toolbar-title");
				let p = document.createElement("p");
				p.classList.add("fc-intro-text");
				p.textContent = this.$root.introText;
				h2.insertAdjacentElement('afterend', p);
			}
		}
  },
  watch: {
    "resize.size"() {
      this.setView();
    },
  },
  async created() {
    await this.getData();
    this.resize_init();
  },
  mounted() {
    this.calendar = this.$refs.fullCalendar.getApi();
		this.addintroText();
    this.getData();
  },
};
